import { tooltipLegacyDriverFactory } from '../Tooltip/Tooltip.driver';
import { dataHooks } from './constants';
import deprecationTestkitLog from '../utils/deprecationTestkitLog';

const infoIconDriverFactory = ({ element, eventTrigger }) => {
  deprecationTestkitLog(
    'infoIconTestkitFactory legacy testkit is deprecated and will be removed in next major release. Please use the InfoIconTestkit unidriver testkit instead.',
  );

  const getTooltip = () =>
    tooltipLegacyDriverFactory({
      element: element.querySelector(`[data-hook="${dataHooks.tooltip}"]`),
      eventTrigger,
    });

  return {
    /** returns whether element is rendered */
    exists: () => !!element,

    /** returns element **/
    element: () => element,

    /** Hover on icon. */
    hover: () => getTooltip().mouseEnter(),

    /** Get size. */
    getSize: () => element.getAttribute('data-size'),

    /** Get content as a tooltip text value. */
    getContent: () => getTooltip().getTooltipText(),
  };
};

export default infoIconDriverFactory;
